import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectLiners} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {
  RESET_DESIGN_OPTIONS,
  UPDATE_DESIGN_OPTIONS,
} from '~/common/fabric/reducers/fabricDesign/constants';
import {
  selectHasLinerIdChanged,
  selectLinerId,
} from '~/common/fabric/reducers/fabricDesign/selectors';

export const useLiners = () => {
  const dispatch = useDispatch();
  const liners = useSelector(selectLiners);
  const linerId = useSelector(selectLinerId);
  const hasLinerChanged = useSelector(selectHasLinerIdChanged);

  const linerIcons = useMemo(
    () => liners?.map(({media}) => media.find(({label}) => label === 'icon').url),
    [liners]
  );

  const onLinerReset = useCallback(() => {
    dispatch({
      type: RESET_DESIGN_OPTIONS,
      payload: ['linerId'],
    });
  }, [dispatch]);

  const onLinerChange = useCallback(
    (icon) => {
      const selected = liners?.find(
        ({media}) => media.find(({label}) => label === 'icon').url === icon
      );
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {linerId: selected.id, premiumFeaturesPristine: false},
      });
    },
    [dispatch, liners]
  );

  const selectedLiner = useMemo(() => {
    const selected = liners?.find(({id}) => id === linerId);
    if (selected) {
      const image = selected.media.find(({label}) => label === 'image').url;
      const icon = selected.media.find(({label}) => label === 'icon').url;
      return {...selected, image, icon};
    }
    return null;
  }, [liners, linerId]);

  return {linerIcons, onLinerChange, onLinerReset, selectedLiner, hasLinerChanged};
};
